import { takeLatest, all, put, fork, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import * as actions from '../../actions/actions'

import {hasBankAdminCorporate, postUser} from '../../../api/userApi'

export default function* userCreateSaga() {
  yield all([
    fork(watchSaveUserEditRequestRequest),
    fork(watchCreateUserIdBankFieldChangeRequest),
    fork(watchCreateUserCorporateSenderIdFieldChangeRequest),
    fork(watchCreateUserFullNameFieldChangeRequest),
    fork(watchCreateUserDescriptionFieldChangeRequest),
    fork(watchCreateUserEnabledFieldChangeRequest),
    fork(watchCreateUserUserNameFieldChangeRequest),
    fork(watchCreateUserPhoneFieldChangeRequest),
    fork(watchCreateUserEmailFieldChangeRequest),
    fork(watchCreateUserResetFieldChangeRequest),
    fork(watchCreateUserPasswordFieldChangeRequest),
    fork(watchCreateUserRoleFieldChangeRequest),
    fork(watchCreateUserLanguageFieldChangeRequest),
    fork(watchCheckBankAdminCorporateRequestRequest),
    fork(watchCreateUserCleanRequest)
  ]);
}

function* watchSaveUserEditRequestRequest() {
  yield takeLatest(
    actions.SAVE_USER_CREATE_REQUEST,
    saveUserRequestEditRequest
  )
}

function* saveUserRequestEditRequest(user) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(postUser, user.value)
    yield put({ type: actions.SAVE_USER_CREATE_SUCCESS, value: data })
    yield put(push(`/user`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    yield put({ type: actions.CREATE_USER_CLEAN_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.SAVE_USER_CREATE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchCheckBankAdminCorporateRequestRequest() {
  yield takeLatest(
      actions.CHECK_BANK_ADMIN_CORPORATE_REQUEST,
      checkBankAdminCorporateRequest
  )
}

function* checkBankAdminCorporateRequest() {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(hasBankAdminCorporate)
    yield put({ type: actions.CHECK_BANK_ADMIN_CORPORATE, value: data })
    // yield put(push(`/user`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    // yield put({ type: actions.CREATE_USER_CLEAN_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.SAVE_USER_CREATE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}


function* watchCreateUserFullNameFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_FULL_NAME_FIELD_CHANGE_REQUEST,
    createUserFullNameFieldChangeRequestRequest
  )
}

function* createUserFullNameFieldChangeRequestRequest(fullName) {
  yield put({ type: actions.CREATE_USER_FULL_NAME_FIELD_CHANGE, value: fullName.value })
}

function* watchCreateUserDescriptionFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_DESCRIPTION_FIELD_CHANGE_REQUEST,
    createUserDescriptionFieldChangeRequest
  )
}

function* createUserDescriptionFieldChangeRequest(description) {
  yield put({ type: actions.CREATE_USER_DESCRIPTION_FIELD_CHANGE, value: description.value })
}

function* watchCreateUserEnabledFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_ENABLED_FIELD_CHANGE_REQUEST,
    createUserEnabledFieldChangeRequest
  )
}

function* createUserEnabledFieldChangeRequest(enable) {
  yield put({ type: actions.CREATE_USER_ENABLED_FIELD_CHANGE, value: enable.value })
}

function* watchCreateUserUserNameFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_USERNAME_FIELD_CHANGE_REQUEST,
    createUserUsernameFieldChangeRequest
  )
}

function* createUserUsernameFieldChangeRequest(username) {
  yield put({ type: actions.CREATE_USER_USERNAME_FIELD_CHANGE, value: username.value })
}

function* watchCreateUserPhoneFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_PHONE_FIELD_CHANGE_REQUEST,
    createUserPhoneFieldChangeRequest
  )
}

function* createUserPhoneFieldChangeRequest(phone) {
  yield put({ type: actions.CREATE_USER_PHONE_FIELD_CHANGE, value: phone.value })
}

function* watchCreateUserEmailFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_EMAIL_FIELD_CHANGE_REQUEST,
    createUserEmailFieldChangeRequest
  )
}

function* createUserEmailFieldChangeRequest(email) {
  yield put({ type: actions.CREATE_USER_EMAIL_FIELD_CHANGE, value: email.value })
}

function* watchCreateUserResetFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_RESET_FIELD_CHANGE_REQUEST,
    createUserResetFieldChangeRequest
  )
}

function* createUserResetFieldChangeRequest(reset) {
  yield put({ type: actions.CREATE_USER_RESET_FIELD_CHANGE, value: reset.value })
}

function* watchCreateUserLanguageFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_LANGUAGE_FIELD_CHANGE_REQUEST,
    createUserLanguageFieldChangeRequest
  )
}

function* createUserLanguageFieldChangeRequest(language) {
  yield put({ type: actions.CREATE_USER_LANGUAGE_FIELD_CHANGE, value: language.value })
}

function* watchCreateUserPasswordFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_PASSWORD_FIELD_CHANGE_REQUEST,
    createUserPasswordFieldChangeRequest
  )
}

function* createUserPasswordFieldChangeRequest(password) {
  yield put({ type: actions.CREATE_USER_PASSWORD_FIELD_CHANGE, value: password.value })
}


function* watchCreateUserRoleFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_ROLE_FIELD_CHANGE_REQUEST,
    createUserRoleFieldChangeRequest
  )
}

function* createUserRoleFieldChangeRequest(role) {
  if(role.value !== null)
    yield put({ type: actions.CREATE_USER_ROLE_FIELD_CHANGE, value: role.value })
  else
    yield put({ type: actions.CREATE_USER_ROLE_FIELD_CHANGE, value: '' })
}

function* watchCreateUserIdBankFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_ID_BANK_FIELD_CHANGE_REQUEST,
    createUserIdBankFieldChangeRequest
  )
}

function* createUserIdBankFieldChangeRequest(idBank) {
  if(idBank.value !== null)
    yield put({type: actions.CREATE_USER_ID_BANK_FIELD_CHANGE, value: idBank.value})
  else
    yield put({type: actions.CREATE_USER_ID_BANK_FIELD_CHANGE, value: ''})
}

function* watchCreateUserCorporateSenderIdFieldChangeRequest() {
  yield takeLatest(
    actions.CREATE_USER_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST,
    createUserCorporateSenderIdFieldChangeRequest
  )
}

function* createUserCorporateSenderIdFieldChangeRequest(corporateSenderId) {
  if(corporateSenderId.value !== null)
    yield put({type: actions.CREATE_USER_CORPORATE_SENDER_ID_FIELD_CHANGE, value: corporateSenderId.value})
  else
    yield put({type: actions.CREATE_USER_CORPORATE_SENDER_ID_FIELD_CHANGE, value: ''})
}

function* watchCreateUserCleanRequest() {
  yield takeLatest(
    actions.CREATE_USER_CLEAN_REQUEST,
    createUserCleanRequest
  )
}

function* createUserCleanRequest() {
  yield put({ type: actions.CREATE_USER_CLEAN })
}

